import { useCallback } from "react";
import useKeyboardListener from "@/common/hooks/useKeyboardListener";
import { useKeyboardShortcutAudioControl } from "./useKeyboardShortcutAudioControl";
import { KeyboardEventHandlerOptions } from "@/types/types.ts";

export const useKeyboardShortcutFastRewind = (options?: KeyboardEventHandlerOptions): void => {
  const { withShortcutCheck, audioAdapter } = useKeyboardShortcutAudioControl(options);

  const fastRewind = useCallback(
    (amount = 10): void => {
      audioAdapter?.fastRewind(amount);
    },
    [audioAdapter]
  );

  useKeyboardListener(
    withShortcutCheck((event) => {
      if (event.ctrlKey || event.metaKey) return;

      if (event.key === "ArrowLeft" || event.keyCode === 37) {
        event.preventDefault();
        fastRewind(event.shiftKey ? 30 : 10);
      }
    })
  );
};
